export const requestDemo = (url = 'https://calendly.com/mashvisor/demo') => {
  if (window.Calendly && window.Calendly.showPopupWidget) {
    window.Calendly.showPopupWidget(url);
  }
};
